module.exports = __webpack_public_path__ + "static/img/item11.cf585a8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/summit/item11.png
// module id = et1o
// module chunks = 1